module.exports = __webpack_public_path__ + "static/img/bg2.8d933d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg2.png
// module id = CjTQ
// module chunks = 0